import { applyMiddleware, combineReducers, createStore } from 'redux';
import { createLogicMiddleware } from 'redux-logic';

import { authReducers, ReduxLogic } from 'common/auth/auth_context';
import { networkReducer as network } from 'common/network-status/network_status_context';

export const store = createStore(
    combineReducers({
        auth: authReducers,
        network,
    }),
    applyMiddleware(createLogicMiddleware([...ReduxLogic]))
);

export type RootState = ReturnType<typeof store.getState>;
